import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import SearchBox from "../search-box";
import NewsCard from "../events/events-card";
import ReactPaginate from "react-paginate";
import Api from '../../../lib/seam-api';
import CustomSelect from '../select';
import NoResults from '../no-results';
import {fireEnquireOpenEvent} from "../../overlay/enquire";
import MeetingCard from '../../../components/meeting-card';
import InputsDate from '../../../components/inputs/inputs-date';
import seamApi from '../../../lib/seam-api';
import { max } from 'lodash';
import dayjs from 'dayjs';
import MediaHelper from '../../../lib/helpers/media';
import InputsDropdown from '../../../components/inputs/inputs-dropdown';
import humanizeDuration from 'humanize-duration';
import MediaQuery from 'react-responsive';

import RenderThisIf from '../../../components/renderIf';

const el = document.getElementById('meetings-index');

import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

class Meetings extends Component {

    constructor(props) {
        super(props);
        this.state = {
            search : '',
            items : [],
            page: 1,
            pageCount : 0,
            cdnUrl : '/images',
            direction : 'desc',
            selectedCapacity: null,
            start: new Date(),
        };

        this.capacities = {
            '2-4': [2, 4],
            '4-8': [4, 8],
            '8-12': [8, 12],
            '15+': [15, 1000]
        }

        this.searchCanceler = null;

        this.titleTag = el.getAttribute('data-tag');
        this.titleText = el.getAttribute('data-title');
    }

    onChangeHandler({target: { value }}) {
        this.setState({
            search : value
        }, () => this.changed());
    }

    componentDidMount() {
        this.fetchItems();
    }

    changed() {
        if(this.state.search.length >= 1) {
            return this.search();
        }

        this.fetchItems();
    }

    search() {
        if(this.searchTimeOut) {
            clearTimeout(this.searchTimeOut);

        }
        if(this.searchCanceler !== null) {
            this.searchCanceler.cancel('Cancel Content Search');
            this.searchCanceler = null;
        }

        this.searchTimeOut = setTimeout(() => {
            Api.content().search(this.state.search, [12], [], searchCanceler => {
                this.searchCanceler = searchCanceler;
            }).then(response => {
                this.setState({
                    items : response.data,
                    pageCount : 0,
                    page : 1,
                    cdnUrl : response.meta.cdn_url
                })
            });
        }, 200);

    }

    fetchItems(page = this.state.page) {
        const min = this.capacities?.[this.state?.selectedCapacity]?.[0];
        const max = this.capacities?.[this.state?.selectedCapacity]?.[1];

        let start = dayjs(this.state?.start).utc();

        seamApi.meetings().getMeetingRooms({
            start: start,
            min_capacity: min,
            max_capacity: max,
            duration_mins: this.state.duration_mins,
            per_page: 1000,
            page: 1,
        }).then(({ data }) => {
            this.setState({
                items: data
            })
        })
    }

    handlePageClick(event) {
        this.setState({ page: event.selected + 1 }, () => this.fetchItems());

    }

    truncateDescription (input) {
        return input?.length > 65 ? `${input.substring(0, 65)}...` : input;
    }

    onStartChange(e) {
        this.setState({ start: e }, () => this.fetchItems());
    }

    onCapacityChange(capacity) {
        this.setState({ selectedCapacity: this.state.selectedCapacity !== capacity ? capacity : null }, () => this.fetchItems())
    }

    onDurationMins(e) {
        this.setState({ duration_mins: e.value }, () => this.fetchItems());
    }

    durationMins() {
        let items = [];

        for (let i = 1; i < (4 * 9) + 1; i++) {
            const milliseconds = (i * 15) * 60000;

            items.push({
                label: humanizeDuration(milliseconds, { units: ['h', 'm'] }),
                value: i * 15,
            })
        }

        return items;
    }

    render() {
        return (
            <>
                <div className="index__search">
                    <div className="index-search__block index-search__text">
                        <h1 className="index-search__title">MAKE IT A MEETING TO REMEMBER</h1>
                    </div>

                    <div className="index-search__block index-search__filters">
                        <div className="index-search__label">
                            <p>How many people will be attending your meeting?</p>

                            <div className="index-search__pills">
                                { Object.keys(this.capacities).map((capacity) => {
                                    return <span className={`index-search__pill pill ${capacity === this.state.selectedCapacity ? 'index-search__pill--active' : ''}`} onClick={() => this.onCapacityChange(capacity)}>{ capacity }</span>
                                })}
                            </div>
                        </div>

                        <div className="index-search__label">
                            <p>When will your meeting take place?</p>

                            <MediaQuery maxWidth={992}>
                                <InputsDate
                                    onChange={this.onStartChange.bind(this)}
                                    value={this.state.start}
                                    dateProps={{
                                        showTimeSelect: true,
                                        timeIntervals: 15,
                                        timeCaption: "Time",
                                        dateFormat: "h:mm aa",
                                        withPortal: true,
                                    }}
                                />
                            </MediaQuery>

                            <MediaQuery minWidth={992}>
                                <InputsDate
                                    onChange={this.onStartChange.bind(this)}
                                    value={this.state.start}
                                    dateProps={{
                                        showTimeSelect: true,
                                        timeIntervals: 15,
                                        timeCaption: "Time",
                                        dateFormat: "h:mm aa",
                                    }}
                                />
                            </MediaQuery>
                        </div>

                        <div className="index-search__label">
                            <p>Duration</p>

                            <InputsDropdown
                                items={this.durationMins()}
                                value={this.state.duration_mins}
                                onChange={this.onDurationMins.bind(this)}
                            />
                        </div>
                    </div>
                </div>

                <h2 className="news__title" data-seam-tag={this.titleTag.split('data-seam-tag=')?.[1]}>{ this.titleText }</h2>

                <RenderThisIf
                    renderIf={this.state.items?.length === 0}
                    render={
                        <NoResults
                            title={'NO MEETING ROOMS FOUND'}
                            subtitle={'Please can you refine your search result or try searching manually.'}
                            content={`Need help finding what you're looking for?`}
                            onClick={e => {
                                e.preventDefault();
                                fireEnquireOpenEvent(0)
                            }}
                        />
                    }
                >
                    <div className="news__items">
                        { this.state.items.map(item => {
                            const getFeaturedImage = () => {
                                const image = item?.content?.room_feature_image?.[0];

                                if (image?.file_name === undefined) return '/images/office.png';

                                return MediaHelper.formatPublicPath(`/images/${image?.file_name}`);
                            }

                            return <MeetingCard
                                room={item}
                                data={{
                                    name: item?.name,
                                    description: this.truncateDescription(item.meta?.preview_description),
                                    slug : `/meetings/${item?.id}`,
                                    background : getFeaturedImage()
                                }}
                            />
                        } )}
                    </div>
                </RenderThisIf>
            </>
        );
    }
}

if(el)  {
    ReactDOM.render(<Meetings/>, el);
}
